import React, { useState } from "react";
import styles from '../index.module.css';
import LoginLogo from '../../../../assets/images/brand/study_hub_logo.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { signInSubmit } from "../../../../redux/features/auth/authService";
import { useDispatch, useSelector } from "react-redux";
import BeatLoader from "react-spinners/BeatLoader";

const Login = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isSignInLoading } = useSelector((state) => state.auth.signInDetails)

    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });

    const [errorMessages, setErrorMessages] = useState({
        username: '',
        password: '',
    });
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const validateFormData = () => {
        const errors = {};
        const validateEmail = (email) =>
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

        if (!formData.email) {
            errors.email = 'Email is required.'
        } else if (!validateEmail(formData.email)) {
            errors.email = 'Email address must be a valid email.';
        }
        if (!formData.password) {
            errors.password = 'Password is required.'
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    }

    const login = async () => {
        try {
            if (validateFormData(formData)) {
                const response = await dispatch(signInSubmit(formData)).unwrap();
                if (response.success) {
                    navigate('/');
                }
            }
        } catch (err) {
            setErrorMsg(err.message);
        }
    }

    const goHome = () => {
        navigate('/');
    }

    return (
        <>
            <div className={styles.authContainer}>
                <div className={styles.authCard}>
                    <div className={styles.authCardHeader}>
                        <img src={LoginLogo} alt="Logo" className={styles.logoImg} onClick={goHome} />
                        <h1 className={styles.authTitle}>Welcome to Studyhub</h1>
                        <div className={styles.subTitleRow}>
                            <p>
                                Don't you have an account?{" "}
                                <Link to="/auth/register" className={styles.loginLink}>
                                    Register
                                </Link>
                            </p>
                        </div>
                    </div>
                    <div className={styles.authCardBody}>
                        <div className={styles.formContainer}>
                            <form noValidate>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Email
                                        </label>
                                        <input
                                            type='text'
                                            id='email'
                                            name='email'
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            placeholder='Enter your email'
                                            className={`form-input-default`}
                                        />
                                        {errorMessages.email && (
                                            <p className={`text-danger`}>{errorMessages.email}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group password-container`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Password
                                        </label>
                                        <div className={`password-wrapper`}>
                                            <input
                                                type={passwordVisible ? "text" : "password"}
                                                id='password'
                                                name='password'
                                                placeholder="********************"
                                                value={formData.password}
                                                onChange={handleInputChange}
                                                className={`form-input-default`}
                                            />
                                            <FontAwesomeIcon
                                                icon={!passwordVisible ? faEyeSlash : faEye}
                                                onClick={() => setPasswordVisible(!passwordVisible)}
                                                className={`password-icon`}
                                            />
                                        </div>
                                        {errorMessages.password && (
                                            <p className={`text-danger`}>{errorMessages.password}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={styles.bottomRow}>
                                    <Link to="/auth/forgot-password" className={styles.loginLink}>
                                        Forgot your Password?
                                    </Link>
                                </div>
                                {errorMsg && (
                                    <p className={`text-danger`}>{errorMsg}</p>
                                )}
                                <button
                                    className={styles.authBtn}
                                    type='button'
                                    disabled={isSignInLoading}
                                    onClick={login}
                                >
                                    {isSignInLoading ? <BeatLoader color='#ffffff' /> : `Login`}
                                </button>
                            </form>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default Login;